define("settings/templates/subscription", ["exports", "@ember/template-factory"], function (_exports, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _default = (0, _templateFactory.createTemplateFactory)({
    "id": "E1zgJSTL",
    "block": "[[[41,[30,0,[\"isPageRestricted\"]],[[[1,\"  \"],[8,[39,1],null,[[\"@description\"],[[28,[37,2],[\"account.restricted_page.subscription_title\"],[[\"email\"],[[33,3]]]]]],null],[1,\"\\n\"]],[]],[[[1,\"  \"],[8,[39,4],null,null,null],[1,\"\\n\\n  \"],[46,[28,[37,6],null,null],null,null,null],[1,\"\\n\"]],[]]]],[],false,[\"if\",\"restricted-page\",\"t\",\"accountOwnerEmail\",\"migration-banner\",\"component\",\"-outlet\"]]",
    "moduleName": "settings/templates/subscription.hbs",
    "isStrictMode": false
  });

  _exports.default = _default;
});